import { INCOME_STATEMENT_PROP } from 'common/constants/financials';
import { FinancialStatementPeriod } from 'common/types/financials';

const getVisibleColumnsFromPeriods = ({
  periods,
  accessedProperty,
}: {
  periods: FinancialStatementPeriod[];
  accessedProperty: string;
  template: FinancialStatementPeriod;
}) => {
  const filterCondition =
    accessedProperty === INCOME_STATEMENT_PROP
      ? (period: FinancialStatementPeriod) => !period.is_deleted
      : (period: FinancialStatementPeriod) => !period.is_deleted && !period.isNTM;

  return periods.filter(period => filterCondition(period));
};

export default getVisibleColumnsFromPeriods;
